import React from 'react';
import {
  UcatTimedPreScreen,
  UcatSubtestTable,
  ucatBodyText,
  ucatSectionHeading,
  formatUcatExtraTimeLabel,
} from './UcatTimedPreScreen';
import { getUcatModuleDurationMinutes } from '../utils/getUcatModuleDurationMinutes';

/** Screenshot 3 — Verbal Reasoning instructions (1 minute 30 seconds). */

const VR_FALLBACK = { name: 'Verbal Reasoning', questions: '44', ucat: '22 minutes', extra: '27 minutes 30 seconds' };

const UcatVrInstructionsScreen = ({
  paperTitle,
  colorScheme,
  setColorScheme,
  onNext,
  pearsonSitting = false,
  pearsonModules = [],
}) => {
  const vrMod = Array.isArray(pearsonModules)
    ? pearsonModules.find((mod) => mod?.moduleKey === 'verbal_reasoning') || pearsonModules[0]
    : null;
  const slotMinutes = Number(vrMod?.durationMinutes);
  const useSlotMinutes = pearsonSitting && Array.isArray(pearsonModules) && pearsonModules.length === 1
    && Number.isFinite(slotMinutes) && slotMinutes > 0;
  const vrMinutes = useSlotMinutes
    ? slotMinutes
    : getUcatModuleDurationMinutes(vrMod || { moduleKey: 'verbal_reasoning' });
  const vrCount = Array.isArray(vrMod?.questions) && vrMod.questions.length
    ? String(vrMod.questions.length)
    : VR_FALLBACK.questions;
  const vrRows = pearsonSitting
    ? [{
      name: 'Verbal Reasoning',
      questions: vrCount,
      ucat: `${vrMinutes} minutes`,
      extra: formatUcatExtraTimeLabel(vrMinutes) || VR_FALLBACK.extra,
    }]
    : [VR_FALLBACK];

  return (
    <UcatTimedPreScreen
      paperTitle={paperTitle}
      colorScheme={colorScheme}
      setColorScheme={setColorScheme}
      onNext={onNext}
      durationSeconds={90}
      showHelp
      showEndExam={false}
      pearsonSitting={pearsonSitting}
      examName="UCAT"
    >
      {({ ink, scheme }) => {
        const body = ucatBodyText(ink);
        const heading = ucatSectionHeading(ink);
        return (
          <>
            <p style={{ ...body, fontWeight: 700 }}>
              You have 1 minute 30 seconds to read this screen.
            </p>
            <p style={{ ...heading, fontSize: '16px', marginBottom: '16px' }}>
              VERBAL REASONING INSTRUCTIONS
            </p>
            <UcatSubtestTable ink={ink} scheme={scheme} rows={vrRows} />
            <p style={body}>For each question you may only select one response.</p>
            <p style={body}>
              It is in your best interest to answer all questions as there is no penalty for guessing. Unanswered questions will be scored as incorrect.
            </p>
            <p style={body}>
              The <strong>&apos;Navigator&apos;</strong> function at the bottom right of the screen allows you to navigate to questions within the subtest.
            </p>
            <p style={body}>
              Refer to the <strong>Help</strong> button for guidance on problems during testing. Test time will continue to count down while using the Help button.
            </p>
            <p style={{ ...body, marginBottom: 0 }}>
              Please click the{' '}
              <strong>
                Next (<span style={{ textDecoration: 'underline' }}>N</span>)
              </strong>{' '}
              button to proceed before the time on this screen expires.
            </p>
          </>
        );
      }}
    </UcatTimedPreScreen>
  );
};

export default UcatVrInstructionsScreen;
